const state = {
	searchText: null,
}

const getters = {
	searchText: state => {
		return state.searchText;
	}
}

const actions = {
	searchTextHandler(context, payload){
		context.commit('searchTextHandler', payload);
	}
}

const mutations = {
	searchTextHandler(state, searchText){
		state.searchText = searchText;
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/search/index.js